export enum CustomFieldFormTypeEnum {
  basic = 0,
  pageView = 1,
}
